import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import PodBanner from '../../components/PodBanner';
import ApplicationFee from './ApplicationFee';
import AcceptanceRate from './AcceptanceRate';
import Deadline from '../shared/Deadline';
import ImportantPolicies from './ImportantPolicies';
import Scattergrams from './Scattergrams';
import ApplicationRequirements from './ApplicationRequirements';
import RecommendedCourses from './RecommendedCourses';
import ApplicationInformation from './ApplicationInformation';
import HighSchoolApplicationStats from './HighSchoolApplicationStats';
import Contact from './Contact';
import ApplicationFactors from './ApplicationFactors';
import CommonBlackCollegeApp from './CommonBlackCollegeApp';

const AdmissionsMenu = ({
  admissionsData,
  admissionsContact,
  highSchool,
  applicationStatistics,
  collegeName,
  userData,
  isCommonAppDeadlinesFlagOn,
  featureFlags,
  ...rest
}) => {
  const deadline = get(admissionsData, 'deadlines[0]', {});
  const applicationFee = get(admissionsData, 'fees.applicationFee.value', '');
  const importantPolicies = get(admissionsData, 'importantPolicies', {});
  const scattergrams = get(applicationStatistics, 'scattergrams', {});
  const userInfo = get(applicationStatistics, 'userInfo', {});
  const applicationsByYear = get(applicationStatistics, 'applicationsByYear', {});
  const commonBlackCollegeApp = get(admissionsData, 'commonBlackCollegeApp', {});
  const isNavianceStudentAdmissionsIncludeCBCA = get(
    featureFlags,
    'releaseNavianceStudentAdmissionsIncludeCBCA',
    false,
  );

  return (
    <div className="student-life-container common-full-width">
      <PodBanner>
        <Deadline {...deadline} featureFlags={featureFlags} />
        <ApplicationFee applicationFee={applicationFee} />
        <AcceptanceRate
          acceptanceRate={get(admissionsData, 'acceptanceRate', {})}
          lastUpdated={get(admissionsData, 'lastUpdated.value', '')}
          admissionsTab
        />
        <ImportantPolicies importantPolicies={importantPolicies} />
        {isNavianceStudentAdmissionsIncludeCBCA &&
          commonBlackCollegeApp?.isCBCA?.value && <CommonBlackCollegeApp />}
      </PodBanner>
      {
        /* istanbul ignore next */ !isEmpty(applicationsByYear) && (
          <HighSchoolApplicationStats applicationsByYear={applicationsByYear} />
        )
      }
      {!isEmpty(scattergrams) && featureFlags && (
        <Scattergrams
          highSchool={highSchool}
          scattergrams={scattergrams}
          userData={userData}
          userInfo={userInfo}
          featureFlags={featureFlags}
        />
      )}
      <ApplicationRequirements admissionsData={admissionsData} {...rest} />
      <RecommendedCourses
        admissionsData={admissionsData}
        collegeName={collegeName}
        {...rest}
      />
      <ApplicationFactors
        collegeName={collegeName}
        applicationFactors={get(admissionsData, 'applicationFactors', [])}
      />
      <ApplicationInformation
        admissionsData={admissionsData}
        isCommonAppDeadlinesFlagOn={isCommonAppDeadlinesFlagOn}
        {...rest}
      />
      <Contact
        admissionsContact={admissionsContact}
        lastUpdated={get(admissionsData, 'lastUpdated.value', '')}
        {...rest}
      />
    </div>
  );
};

AdmissionsMenu.propTypes = {
  admissionsData: PropTypes.object,
  admissionsContact: PropTypes.object,
  highSchool: PropTypes.object,
  applicationStatistics: PropTypes.object,
  userData: PropTypes.object,
  deliveryType: PropTypes.string,
  isApplyingTo: PropTypes.bool,
  websiteUrl: PropTypes.string,
  collegeName: PropTypes.string,
  isCommonAppDeadlinesFlagOn: PropTypes.bool,
  featureFlags: PropTypes.object,
};

export default AdmissionsMenu;
